/*import { Table, Container } from 'reactstrap';*/
import React, { useState, useEffect } from "react";
import { Table, Container, Input, Row, Col, Button, Form, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import Swal from "sweetalert2";
import "../UserLogin.css";


/*import ReactFileReader from 'react-file-reader';*/


export function Report19201() {

    const [Re19201data, setRe19201data] = useState([]);
    /* const [date191data, setdate19201data] = useState([{ updateDate: '' }]);*/

    async function getR19201() {
        const res19201 = await fetch("/api/BorrowReports/getV19201")
        const Re19201data = await res19201.json()
        setRe19201data(Re19201data.dataenum)
        // console.log(Re19201data)
    }
    React.useEffect(() => {
        getR19201()
    }, []);

    let namesArr = {};
    const rowSpan = Re19201data.reduce((result, item, key) => {
        if (namesArr[item.dept] === undefined) {
            namesArr[item.dept] = key;
            result[key] = 1;
        } else {
            const firstIndex = namesArr[item.dept];
            if (
                firstIndex === key - 1 ||
                (item.dept === Re19201data[key - 1].name && result[key - 1] === 0)
            ) {
                result[firstIndex]++;
                result[key] = 0;
            } else {
                result[key] = 1;
                namesArr[item.dept] = key;
            }
        }
        return result;
    }, []);





    //////////////////////////////////////////////////////////////////////////////////////
    const [fileInput, setFileInput] = useState(null);
    const [fileError, setFileError] = useState(null);
    const [openModalFileForm, setOpenModalFileForm] = useState(false);
    const modalFileToggle = () => setOpenModalFileForm(!openModalFileForm);


    const importFileSubmit = async (e) => {
        e.preventDefault();
        if (fileInput) {
            let postData = new FormData()
            postData.append("file", fileInput)
            let res = await fetch("/api/BorrowReports/getUpload", {
                method: "POST",
                body: postData
            })
            let resJson = await res.json()
            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "นำเข้าข้อมูลสำเร็จ",
                    text: "",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",

                })
                modalFileToggle();
            } else {
                Swal.fire({
                    icon: "error",
                    title: "นำเข้าข้อมูลไม่สำเร็จ",
                    text: `เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }
        }
        else {
            Swal.fire({
                icon: "info",
                title: "กรุณาแนบไฟล์",
                text: "",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            })
        }
    }



    const handleFileInputChange = (e) => {
        const file = e.target.files[0];
        const allowedTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        const maxSize = 10000000; // 10 MB

        if (file && !allowedTypes.includes(file.type)) {
            setFileError('รองรับเฉพาะไฟล์ excel');
            setFileInput(null);
        } else if (file && file.size > maxSize) {
            setFileError('ขนาดไฟล์ต้องไม่เกิน 10 MB');
            setFileInput(null);
        } else {
            setFileError(null);
            setFileInput(file);
        }

    }

    //////////////////////////////////////////////////////////////////////////////////


    const [fileInput1, setFileInput1] = useState(null);
    const [fileError1, setFileError1] = useState(null);
    const [openModalFileForm1, setOpenModalFileForm1] = useState(false);
    const modalFileToggle1 = () => setOpenModalFileForm1(!openModalFileForm1);

    const importFileSubmit1 = async (e) => {
        e.preventDefault();
        if (fileInput1) {
            let postData = new FormData()
            postData.append("file", fileInput1)
            let res = await fetch("/api/BorrowReports/getUpload1", {
                method: "POST",
                body: postData
            })
            let resJson = await res.json()
            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "นำเข้าข้อมูลสำเร็จ",
                    text: "",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                })
                modalFileToggle1();
            } else {
                Swal.fire({
                    icon: "error",
                    title: "นำเข้าข้อมูลไม่สำเร็จ",
                    text: `เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }
        }
        else {
            Swal.fire({
                icon: "info",
                title: "กรุณาแนบไฟล์",
                text: "",
                confirmButtonColor: "#0A66C2",
                confirmButtonText: "ตกลง",
            })
        }
    }

    const handleFileInputChange1 = (e) => {
        const file = e.target.files[0];
        const allowedTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
        const maxSize = 10000000; // 10 MB

        if (file && !allowedTypes.includes(file.type)) {
            setFileError1('รองรับเฉพาะไฟล์ excel');
            setFileInput1(null);
        } else if (file && file.size > maxSize) {
            setFileError1('ขนาดไฟล์ต้องไม่เกิน 10 MB');
            setFileInput1(null);
        } else {
            setFileError1(null);
            setFileInput1(file);
        }

    }

    return (
        <Container>
            <Form
                onSubmit={importFileSubmit}
            >
                <Modal
                    isOpen={openModalFileForm}
                    toggle={modalFileToggle}
                    centered
                    backdrop={"static"}
                    keyboard={false}
                >
                    <ModalHeader toggle={modalFileToggle}>นำเข้าข้อมูลรายงาน ไฟล์ที่1</ModalHeader >
                    <ModalBody>
                        <Input
                            type="file"
                            id="fileInput"
                            onChange={handleFileInputChange}
                        >
                        </Input>
                        {fileError && <span className="text-danger">{fileError}</span>}
                        <ModalFooter>
                            <button className="btn border-1 border" type="submit" onClick={(e) => { importFileSubmit(e) }}>ยืนยัน</button>
                            <button className="btn border-1 border" type="button" onClick={() => modalFileToggle(!openModalFileForm)}>ยกเลิก</button>
                        </ModalFooter>

                    </ModalBody>
                </Modal>
            </Form>

            <Form
                onSubmit={importFileSubmit1}
            >
                <Modal
                    isOpen={openModalFileForm1}
                    toggle={modalFileToggle1}
                    centered
                    backdrop={"static"}
                    keyboard={false}
                >
                    <ModalHeader toggle={modalFileToggle1}>นำเข้าข้อมูลรายงาน ไฟล์ที่2</ModalHeader>
                    <ModalBody>
                        <Input
                            type="file"
                            id="fileInput1"
                            onChange={handleFileInputChange1}
                        >
                        </Input>
                        {fileError1 && <span className="text-danger">{fileError1}</span>}
                        <ModalFooter>
                            <button className="btn border-1 border" type="submit" onClick={(e) => { importFileSubmit1(e) }}>ยืนยัน</button>
                            <button className="btn border-1 border" type="button" onClick={() => modalFileToggle1(!openModalFileForm)}>ยกเลิก</button>
                        </ModalFooter>
                    </ModalBody>
                </Modal>
            </Form>

            <div>
                <h4 className='text-center'>
                    ณ วันที่ 8 ม.ค. พ.ศ.2565
                </h4>

                <Row>
                    <Col className='d-flex justify-content-end my-2'>
                        <button
                            type="button"
                            className="btn border border-1 mx-1"
                            onClick={() => { modalFileToggle(!openModalFileForm) }}
                        >
                            นำเข้าข้อมูลรายงาน ไฟล์ที่1
                        </button>
                        <button
                            type="button"
                            className="btn border border-1 mx-1"
                            onClick={() => { modalFileToggle1(!openModalFileForm1) }}
                        >
                            นำเข้าข้อมูลรายงาน ไฟล์ที่ 2
                        </button>
                    </Col>
                </Row>



                <Table className="styled-table" bordered striped hover>
                    <thead>
                        <tr>
                            {/*<th rowSpan='3' className='text-center'>*/}
                            {/*    ที่*/}
                            {/*</th>*/}
                            <th rowSpan='3' className='text-center'>
                                หน่วยงาน
                            </th>
                            <th rowSpan='3' className='text-center'>
                                บริษัท
                            </th>
                            <th rowSpan='3' className='text-center'>
                                วงเงินที่ได้รับการอนุมัติ
                            </th>
                            <th colSpan='6' className='text-center'>
                                ข้อมูลให้กู้ยืม
                            </th>
                            <th colSpan='5' className='text-center'>
                                ข้อมูลการชำระหนี้
                            </th>
                            <th rowSpan='3' className='text-center'>
                                คงเหลือ
                            </th>
                        </tr>
                        <tr>
                            <th rowSpan='2' className='text-center'>
                                วงเงินที่ทำสัญญา
                            </th>
                            <th rowSpan='2' className='text-center'>
                                วันที่ทำสัญญากู้ยืม
                            </th>
                            <th rowSpan='2' className='text-center'>
                                จำนวนงวดที่ต้องชำระ
                            </th>
                            <th rowSpan='2' className='text-center'>
                                เริ่มชำระงวดแรก(เดือน)
                            </th>
                            <th rowSpan='2' className='text-center'>
                                วันครบกำหนดชำระเงิน
                            </th>
                            <th rowSpan='2' className='text-center'>
                                ยอดเงินที่ต้องชำระ/งวด
                            </th>
                            <th rowSpan='2' className='text-center'>
                                งวดที่
                            </th>
                            <th rowSpan='2' className='text-center'>
                                วันที่ชำระเงิน
                            </th>
                            <th colSpan='3' className='text-center'>
                                จำนวนเงิน
                            </th>
                        </tr>
                        <tr>
                            <th className='text-center'>
                                เงินต้น
                            </th>
                            <th className='text-center'>
                                ดอกเบี้ย
                            </th>
                            <th className='text-center'>
                                รวม
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {Re19201data.length > 0 && Re19201data.map((item, i) => (

                            < tr >
                                {/* {rowSpan[i] > 0 && <th rowSpan={rowSpan[i]} className='text-center'>{i+1}</th>}*/}
                                {rowSpan[i] > 0 && <th rowSpan={rowSpan[i]} className='text-center'>{item.dept}</th>}
                                {rowSpan[i] > 0 && <th rowSpan={rowSpan[i]} className='text-center'>{item.borrowName}</th>}
                                {rowSpan[i] > 0 && <th rowSpan={rowSpan[i]} className='text-center'>{item.approveAmt}</th>}
                                {rowSpan[i] > 0 && <th rowSpan={rowSpan[i]} className='text-center'>{item.contactAmt}</th>}
                                {rowSpan[i] > 0 && <th rowSpan={rowSpan[i]} className='text-center'>{item.cantactDate}</th>}
                                {rowSpan[i] > 0 && <th rowSpan={rowSpan[i]} className='text-center'>{item.installment}</th>}
                                {rowSpan[i] > 0 && <th rowSpan={rowSpan[i]} className='text-center'>{item.firstPaymentDate}</th>}
                                {rowSpan[i] > 0 && <th rowSpan={rowSpan[i]} className='text-center'>{item.lastPaymentDate}</th>}
                                {rowSpan[i] > 0 && <th rowSpan={rowSpan[i]} className='text-center'>{item.paymentAmt}</th>}


                                {/*<td  className='text-center'>*/}
                                {/*    {i + 1}*/}
                                {/* </td>*/}

                                {/*<td  className='text-center'>*/}
                                {/*    {item.dept}*/}
                                {/*</td>*/}
                                {/*<td  className='text-center'>*/}
                                {/*    {item.borrowName}*/}
                                {/*</td>*/}
                                {/*<td  className='text-center'>*/}
                                {/*    {item.approveAmt}*/}
                                {/* </td>*/}

                                {/*<td  className='text-center'>*/}
                                {/*    {item.contactAmt}*/}
                                {/* </td>*/}

                                {/*<td  className='text-center'>*/}
                                {/*    {item.cantactDate}*/}
                                {/* </td>*/}

                                {/*<td  className='text-center'>*/}
                                {/*    {item.installment}*/}
                                {/* </td>*/}

                                {/*<td  className='text-center'>*/}
                                {/*    {item.firstPaymentDate}*/}
                                {/* </td>*/}

                                {/*<td  className='text-center'>*/}
                                {/*    {item.lastPaymentDate}*/}
                                {/* </td>*/}

                                {/*<td  className='text-center'>*/}
                                {/*    {item.paymentAmt}*/}
                                {/* </td>*/}

                                <th className='text-center'>
                                    {item.installmentNo}
                                </th>
                                <th className='text-center'>
                                    {item.paymentDate}
                                </th>
                                <th className='text-center'>
                                    {item.amount}
                                </th>
                                <th className='text-center'>
                                    {item.interest}
                                </th>
                                <th className='text-center'>

                                </th>
                                <th className='text-center'>

                                </th>
                            </tr>

                        ))}

                    </tbody>
                </Table>
            </div>
        </Container>

    );


}